import React from 'react';
import { AlertCircle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', 
          justifyContent: 'center', height: '100vh', padding: '20px', 
          textAlign: 'center', backgroundColor: '#f2f0eb', color: '#1a1a1a'
        }}>
          <AlertCircle size={48} style={{ color: '#ef4444', marginBottom: '16px' }} />
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '12px' }}>Oops! Something went wrong.</h2>
          <p style={{ color: '#6b7280', marginBottom: '24px', maxWidth: '400px' }}>
            We're sorry, but an unexpected error occurred. Please try refreshing the page or navigating back home.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                background: '#1D9E75', color: 'white', border: 'none', 
                borderRadius: '8px', padding: '10px 20px', fontWeight: 'bold', 
                cursor: 'pointer'
              }}
            >
              Refresh Page
            </button>
            <button 
              onClick={() => window.location.href = '/'}
              style={{
                background: 'white', color: '#1a1a1a', border: '1px solid #d1d5db', 
                borderRadius: '8px', padding: '10px 20px', fontWeight: 'bold', 
                cursor: 'pointer'
              }}
            >
              Go Home
            </button>
          </div>
          {process.env.NODE_ENV === 'development' && (
            <pre style={{
              marginTop: '32px', padding: '16px', background: '#f871711a', 
              color: '#ef4444', borderRadius: '8px', textAlign: 'left', 
              overflowX: 'auto', maxWidth: '800px', fontSize: '12px'
            }}>
              {this.state.error?.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
